namespace GeniuzPOS.Product {
    export interface QryMasterRow {
        Id?: number;
        UrlReport?: string;
        SkuCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        StyleId?: string;
        ColorId?: string;
        SizeId?: string;
        TasteId?: string;
        MatTypeId?: string;
        SkuEnDesc?: string;
        SkuDesc?: string;
        StockFg?: number;
        SupplierId?: string;
        VatType?: string;
        ConsignFg?: number;
    }

    export namespace QryMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'UrlReport';
        export const localTextPrefix = 'Product.QryMaster';
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            UrlReport = "UrlReport",
            SkuCode = "SkuCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            StyleId = "StyleId",
            ColorId = "ColorId",
            SizeId = "SizeId",
            TasteId = "TasteId",
            MatTypeId = "MatTypeId",
            SkuEnDesc = "SkuEnDesc",
            SkuDesc = "SkuDesc",
            StockFg = "StockFg",
            SupplierId = "SupplierId",
            VatType = "VatType",
            ConsignFg = "ConsignFg"
        }
    }
}
